document.addEventListener("DOMContentLoaded", function () {
  try {

    // Capture source when first arriving
    var params = new URLSearchParams(window.location.search);
    var from = params.get("from");

    if (from === "connect") {
      sessionStorage.setItem("prayer_return_href", "/pages/connect");
      sessionStorage.setItem("prayer_return_label", "Return to Connect");
    } else if (from === "home") {
      sessionStorage.setItem("prayer_return_href", "/");
      sessionStorage.setItem("prayer_return_label", "Return to Home");
    }

    // Apply button if it exists (success state)
    var btn = document.getElementById("returnBtn");
    var wrap = document.querySelector("#prayer-app .prayer-app__successActions");

    if (!btn || !wrap) return;

    var href = sessionStorage.getItem("prayer_return_href") || "/";
    var label = sessionStorage.getItem("prayer_return_label") || "Return to Home";

    btn.href = href;
    btn.textContent = label;
    wrap.hidden = false;

  } catch (e) {}
});
btn.addEventListener("click", function(){
  sessionStorage.removeItem("prayer_return_href");
  sessionStorage.removeItem("prayer_return_label");
});